import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import IdCardVisual from "../components/IdCardVisual";
import { api } from "../lib/api";
import { useSite } from "../context/SiteContext";

export default function CardView() {
  const { id } = useParams();
  const { settings } = useSite();
  const [card, setCard] = useState(undefined); // undefined=loading, null=not found

  useEffect(() => {
    api.getIdCard(id).then((r) => setCard(r.data)).catch(() => setCard(null));
  }, [id]);

  return (
    <div data-testid="card-view-page" className="min-h-screen bg-bone pt-32 pb-24">
      <div className="max-w-[1600px] mx-auto px-6">
        {card === undefined && <p className="text-center text-muted">Loading card…</p>}
        {card === null && (
          <div className="text-center">
            <h1 className="font-serif text-4xl text-forest mb-4">Card not found</h1>
            <Link to="/id-card" className="text-gold underline">Register a new ID card</Link>
          </div>
        )}
        {card && (
          <>
            <div className="text-center mb-10">
              <p className="text-xs uppercase tracking-[0.3em] text-gold mb-2">Verified Record</p>
              <h1 className="font-serif text-4xl md:text-5xl text-forest">{card.card_no}</h1>
            </div>
            <div className="print-area"><IdCardVisual data={card} college={settings.college} logo={settings.images && settings.images.logo} /></div>
            <div className="no-print flex flex-wrap gap-4 justify-center mt-12">
              <button data-testid="card-view-print" onClick={() => window.print()} className="inline-flex items-center gap-2 bg-forest text-bone px-7 py-3.5 rounded-full text-sm uppercase tracking-widest hover:-translate-y-0.5 transition-transform">
                <Printer size={16} /> Print / Save PDF
              </button>
              <Link to="/id-card" className="inline-flex items-center gap-2 border border-forest text-forest px-7 py-3.5 rounded-full text-sm uppercase tracking-widest hover:bg-forest hover:text-bone transition-colors">
                <ArrowLeft size={16} /> New Registration
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
